import React, { Component } from 'react';
//import { simpleRestClient } from 'admin-on-rest';
import { connect } from 'react-redux';
import { Button } from 'react-admin';
import {
  contributionApprove as contributionApproveAction,
  deleteContributionFromMission as deleteContributionFromMissionAction
} from './contributionActions';

import DeleteIcon from '@material-ui/icons/Delete';

class DeleteButton extends Component {
  handleClick = (record, missionId) => {
    this.props.deleteContributionFromMissionAction(record, missionId);
  };

  render() {
    let {
      contributionId,
      label,
      missionId,
      record,
      roleLevel,
      ...rest
    } = this.props;

    return (
      roleLevel > 1 && (
        <Button
          //label={label}
          {...rest}
          onClick={event => {
            this.handleClick(record, missionId ? missionId : record.missionId);
          }}
          style={{ marginRight: 0 }}
        >
          <DeleteIcon
            style={{
              color: 'grey',
              padding: 5
              //border: '2px solid grey',
              // borderRadius: '30%',
              //boxShadow: '2px 2px 5px grey'
            }}
          />
        </Button>
      )
    );
  }
}

// const mapStateToProps = state => {
//   // console.log('mapStateToProps', state);
//   // const newState = state;
//   // return newState;
//   const { contributionId } = state;
//   return { contributionId };
// };

export default connect(
  null,
  {
    contributionApproveAction,
    deleteContributionFromMissionAction
  }
)(DeleteButton);



// WEBPACK FOOTER //
// ./src/contributions/DeleteButton.js